export const commercialVocabulary = [
  {
    word: "Entrance",
    meaning: "입구",
    audioId: 1,
  },
  {
    word: "Storefront",
    meaning: "상점 전면",
    audioId: 2,
    imageUrl: "/images/vocabulary/commercial/shopping2.png",
  },
  {
    word: "Clothing",
    meaning: "의류",
    audioId: 3,
  },
  {
    word: "Apparel",
    meaning: "의류, 의복",
    audioId: 4,
  },
  {
    word: "Garments",
    meaning: "의류, 옷",
    audioId: 5,
  },
  {
    word: "Hanger",
    meaning: "옷걸이",
    audioId: 6,
  },
  {
    word: "Rack",
    meaning: "옷걸이 행거",
    audioId: 7,
    imageUrl: "/images/vocabulary/commercial/shopping7.png",
  },
  {
    word: "Aisle shelves",
    meaning: "통로 선반",
    audioId: 8,
    imageUrl: "/images/vocabulary/commercial/shopping8.png",
  },
  {
    word: "Cash register",
    meaning: "계산대",
    audioId: 9,
    imageUrl: "/images/vocabulary/commercial/shopping9.png",
  },
  {
    word: "Produce",
    meaning: "농산물",
    audioId: 10,
    imageUrl: "/images/vocabulary/commercial/shopping10.png",
  },
  {
    word: "Line with",
    meaning: "~을 늘어놓다",
    audioId: 11,
  },
  {
    word: "Checkout counter",
    meaning: "계산대",
    audioId: 12,
  },
  {
    word: "Dining table",
    meaning: "식탁",
    audioId: 13,
  },
  {
    word: "Dining area",
    meaning: "식사 공간",
    audioId: 14,
  },
  {
    word: "Table centerpiece",
    meaning: "테이블 중앙 장식품",
    audioId: 15,
    imageUrl: "/images/vocabulary/commercial/shopping15.png",
  },
  {
    word: "Awning",
    meaning: "차양, 천막",
    audioId: 16,
    imageUrl: "/images/vocabulary/commercial/shopping16.png",
  },
  {
    word: "Lighting",
    meaning: "조명",
    audioId: 17,
  },
  {
    word: "Sidewalk",
    meaning: "보도, 인도",
    audioId: 18,
  },
  {
    word: "Outdoor terrace",
    meaning: "야외 테라스",
    audioId: 19,
  },
  {
    word: "Plastic bag",
    meaning: "비닐봉지",
    audioId: 20,
  },
  {
    word: "Beach umbrellas",
    meaning: "파라솔",
    audioId: 21,
  },
  {
    word: "Patio umbrellas",
    meaning: "파티오 파라솔",
    audioId: 22,
    imageUrl: "/images/vocabulary/commercial/shopping22.png",
  },
  {
    word: "Pedestrian area",
    meaning: "보행자 구역",
    audioId: 23,
    imageUrl: "/images/vocabulary/commercial/shopping23.png",
  },
  {
    word: "Menu board",
    meaning: "메뉴판",
    audioId: 24,
  },
  {
    word: "Chalkboard sign",
    meaning: "칠판 간판",
    audioId: 25,
  },
  {
    word: "Shoe racks",
    meaning: "신발 진열대",
    audioId: 26,
  },
  {
    word: "Hang on",
    meaning: "걸려있다",
    audioId: 27,
  },
  {
    word: "Pour",
    meaning: "붓다, 따르다",
    audioId: 28,
  },
  {
    word: "Attached to",
    meaning: "부착된, 붙어있는",
    audioId: 29,
  },
  {
    word: "Displayed on",
    meaning: "전시된, 진열된",
    audioId: 30,
  },
  {
    word: "Be tailored",
    meaning: "수선되다",
    audioId: 31,
  },
  {
    word: "Product",
    meaning: "제품, 상품",
    audioId: 32,
  },
  {
    word: "Merchandise",
    meaning: "상품, 물품",
    audioId: 33,
  },
  {
    word: "Stock",
    meaning: "재고, 물품",
    audioId: 34,
  },
  {
    word: "Items",
    meaning: "물품, 품목",
    audioId: 35,
  },
  {
    word: "Pastries",
    meaning: "페이스트리, 빵 또는 디저트",
    audioId: 36,
    imageUrl: "/images/vocabulary/commercial/shopping36.png",
  },
  {
    word: "Browse",
    meaning: "둘러보다",
    audioId: 37,
  },
  {
    word: "Explore",
    meaning: "탐색하다, 살펴보다",
    audioId: 38,
  },
  {
    word: "View",
    meaning: "살펴보다, 구경하다",
    audioId: 39,
  },
  {
    word: "Inspect",
    meaning: "검사하다, 자세히 살펴보다",
    audioId: 40,
  },
  {
    word: "Review",
    meaning: "검토하다, 다시 살펴보다",
    audioId: 41,
  },
  {
    word: "Reach for",
    meaning: "손을 뻗어 잡다",
    audioId: 42,
    imageUrl: "/images/vocabulary/commercial/shopping42.png",
  },
  {
    word: "Pick up",
    meaning: "집어 들다, 들어올리다",
    audioId: 43,
  },
  {
    word: "Load",
    meaning: "싣다, 적재하다",
    audioId: 44,
  },
  {
    word: "Examine",
    meaning: "살펴보다, 꼼꼼히 확인하다",
    audioId: 45,
  },
  {
    word: "Bag items",
    meaning: "물건을 봉투에 담다",
    audioId: 46,
    imageUrl: "/images/vocabulary/commercial/shopping47.png",
  },
  {
    word: "Stand in line",
    meaning: "줄을 서다",
    audioId: 47,
  },
  {
    word: "Baked goods",
    meaning: "베이커리 제품(오븐에서 구운 모든 종류의 빵과 과자)",
    audioId: 48,
  },
  {
    word: "Load with",
    meaning: "가득 채우다",
    audioId: 49,
  },
  {
    word: "Vendor",
    meaning: "판매자, 노점상",
    audioId: 50,
    imageUrl: "/images/vocabulary/commercial/shopping51.png",
  },
  {
    word: "Retailer",
    meaning: "소매업자",
    audioId: 51,
  },
  {
    word: "Be altered",
    meaning: "수선되다",
    audioId: 52,
  },
  {
    word: "Stall",
    meaning: "가판대, 노점",
    audioId: 53,
    imageUrl: "/images/vocabulary/commercial/shopping54.png",
  },
  {
    word: "Sip",
    meaning: "홀짝이다, 조금씩 마시다",
    audioId: 54,
  },
  {
    word: "Bun",
    meaning: "번, 빵",
    audioId: 55,
  },
  {
    word: "Gear",
    meaning: "기어, 장비",
    audioId: 56,
  },
  {
    word: "Tie",
    meaning: "넥타이",
    audioId: 57,
  },
  {
    word: "Groceries",
    meaning: "식료품",
    audioId: 58,
  },
  {
    word: "Pile",
    meaning: "더미, 쌓아올린 것",
    audioId: 59,
  },
  {
    word: "Stack",
    meaning: "쌓다, 더미",
    audioId: 60,
  },
  {
    word: "Electronic device",
    meaning: "전자 기기",
    audioId: 61,
  },
  {
    word: "Gown",
    meaning: "가운, 긴 드레스",
    audioId: 62,
  },
  {
    word: "Sewing machine",
    meaning: "재봉틀",
    audioId: 63,
    imageUrl: "/images/vocabulary/commercial/shopping63.png",
  },
  {
    word: "Greet",
    meaning: "인사하다, 맞이하다",
    audioId: 64,
  },
  {
    word: "Bouquet",
    meaning: "꽃다발",
    audioId: 65,
    imageUrl: "/images/vocabulary/commercial/shopping65.png",
  },
  {
    word: "Waitress",
    meaning: "여자 웨이터",
    audioId: 66,
  },
  {
    word: "Serve",
    meaning: "서빙하다, 제공하다",
    audioId: 67,
  },
  {
    word: "Approach",
    meaning: "다가가다, 접근하다",
    audioId: 68,
  },
  {
    word: "Dish",
    meaning: "요리, 접시",
    audioId: 69,
  },
  {
    word: "Dining",
    meaning: "식사",
    audioId: 70,
  },
  {
    word: "Plate",
    meaning: "접시",
    audioId: 71,
  },
  {
    word: "Reflection",
    meaning: "반사, 비침",
    audioId: 72,
  },
  {
    word: "Lobby",
    meaning: "로비",
    audioId: 73,
    imageUrl: "/images/vocabulary/commercial/shopping73.png",
  },
  {
    word: "Necklace",
    meaning: "목걸이",
    audioId: 74,
  },
  {
    word: "Unfold",
    meaning: "펼치다, 펴다",
    audioId: 75,
  },
  {
    word: "Florist",
    meaning: "꽃집, 꽃 판매자",
    audioId: 76,
    imageUrl: "/images/vocabulary/commercial/shopping76.png",
  },
  {
    word: "Food stall",
    meaning: "음식 노점",
    audioId: 77,
    imageUrl: "/images/vocabulary/commercial/shopping77.png",
  },
  {
    word: "Climbing gear",
    meaning: "등산 장비",
    audioId: 78,
  },
  {
    word: "Salesperson",
    meaning: "판매원",
    audioId: 79,
  },
  {
    word: "Receipt",
    meaning: "영수증",
    audioId: 80,
    imageUrl: "/images/vocabulary/commercial/shopping80.png",
  },
  {
    word: "Store clerk",
    meaning: "매장 직원",
    audioId: 81,
  },
  {
    word: "Retail store",
    meaning: "소매점",
    audioId: 82,
  },
  {
    word: "Price tag",
    meaning: "가격표",
    audioId: 83,
    imageUrl: "/images/vocabulary/commercial/shopping83.png",
  },
  {
    word: "Grocery bag",
    meaning: "식료품 봉투",
    audioId: 84,
  },
  {
    word: "Cashier",
    meaning: "계산원",
    audioId: 85,
  },
  {
    word: "Attire",
    meaning: "복장, 의상",
    audioId: 86,
  },
  {
    word: "Fabric",
    meaning: "직물, 천",
    audioId: 87,
  },
  {
    word: "Tableware",
    meaning: "식기",
    audioId: 88,
  },
  {
    word: "Concierge",
    meaning: "컨시어지, 안내원",
    audioId: 89,
  },
  {
    word: "Vending machine",
    meaning: "자판기",
    audioId: 90,
    imageUrl: "/images/vocabulary/commercial/shopping90.png",
  },
  {
    word: "Public phone",
    meaning: "공중전화",
    audioId: 91,
  },
  {
    word: "Check out",
    meaning: "계산하다, 체크아웃하다",
    audioId: 92,
  },
  {
    word: "Make a purchase",
    meaning: "구매하다",
    audioId: 93,
  },
  {
    word: "Footwear",
    meaning: "신발류",
    audioId: 94,
  },
  {
    word: "Household goods",
    meaning: "가정용품",
    audioId: 95,
  },
  {
    word: "Home appliances",
    meaning: "가전제품",
    audioId: 96,
  },
];
